var exports = {
  "k": "EmbedAudio.module__container___Ul9mNW",
  "G": "EmbedAudio.module__deleteButton___Ul9mNW",
};

module.exports = exports;
